import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import Typography from "@mui/material/Typography"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import Column from "../../../common/components/Column"
import Row from "../../../common/components/Row"
import { useIsMobile } from "../../../common/utils"
import { selectSubscription } from "../../users/reducer"
import {
  closeTrialFinishedRoadblockDialog,
  openTrialFinishedRoadblockDialog,
  selectTrialFinishedRoadblockDialogData,
} from "../reducer"
import DialogHeader from "./DialogHeader"
import SelectPlanDrawer from "./SelectPlanDrawer"
import { TrialFinishedRoadblockDialogData } from "./trialRoadblockData"

export { TrialFinishedRoadblockDialogData }

export default function TrialFinishedRoadblockDialog() {
  const [selectPlanDrawerOpen, setSelectPlanDrawerOpen] = useState(false)
  const isMobile = useIsMobile()
  const dispatch = useDispatch()
  const data = useSelector(selectTrialFinishedRoadblockDialogData)

  function handleSoftClose() {
    dispatch(closeTrialFinishedRoadblockDialog())
  }

  function handleSubscribeButtonClicked() {
    handleSoftClose()
    setSelectPlanDrawerOpen(true)
  }

  return (
    <Dialog
      open={!!data}
      onClose={handleSoftClose}
      maxWidth="xs"
      fullScreen={isMobile}
      keepMounted
    >
      <DialogHeader
        title={`${data?.featureName || "Feature"} Blocked`}
        onClose={handleSoftClose}
      />
      <DialogContent>
        <Column sx={{ gap: 3 }}>
          <Row sx={{ justifyContent: "center" }}>
            <BlockOutlinedIcon
              sx={{
                fontSize: "5em",
                fill: (theme) => theme.palette.error.main,
              }}
            />
          </Row>
          <Column sx={{ gap: 2 }}>
            <Typography variant="h3" sx={{ textAlign: "center" }}>
              Your OneBase trial has concluded
            </Typography>
            <Typography variant="body1" sx={{ fontSize: "0.9em" }}>
              {data?.subscribeReason}.
            </Typography>
          </Column>
        </Column>
      </DialogContent>
      <SelectPlanDrawer
        open={selectPlanDrawerOpen}
        onClose={() => setSelectPlanDrawerOpen(false)}
      />
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={handleSoftClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubscribeButtonClicked}
        >
          Subscribe
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export const SendingEmailTrialFinishedDialogData =
  new TrialFinishedRoadblockDialogData(
    "Sending Emails",
    "Subscribe to send emails to your candidates"
  )

export function useTrialFinishedDialogUtils() {
  const dispatch = useDispatch()
  const subscription = useSelector(selectSubscription)

  function runOnlyIfSubscribed(
    callback,
    trialFinishedDialogData: TrialFinishedRoadblockDialogData
  ) {
    if (subscription.trialFinished) {
      dispatch(openTrialFinishedRoadblockDialog(trialFinishedDialogData))
    } else {
      callback()
    }
  }

  return {
    runOnlyIfSubscribed,
  }
}
